import { useEffect, useRef, useState, ReactNode } from "react";
import { motion, useInView } from "framer-motion";

const ScrollReveal = ({ children, className = "", delay = 0 }: { children: ReactNode; className?: string; delay?: number }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  const [enhanceMotion, setEnhanceMotion] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setEnhanceMotion(true);
    }
  }, []);

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={false}
      animate={enhanceMotion && isInView ? { opacity: [0.01, 1], y: [14, 0] } : { opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
